export const FETCH_SCREENS_REQUEST = "FETCH_SCREENS_REQUEST";
export const FETCH_SCREENS_SUCCESS = "FETCH_SCREENS_SUCCESS";
export const FETCH_SCREENS_FAILURE = "FETCH_SCREENS_FAILURE";

export const FETCH_SCREEN_REPORT_REQUEST = "FETCH_SCREEN_REPORT_REQUEST";
export const FETCH_SCREEN_REPORT_SUCCESS = "FETCH_SCREEN_REPORT_SUCCESS";
export const FETCH_SCREEN_REPORT_FAILURE = "FETCH_SCREEN_REPORT_FAILURE";

